import { render, staticRenderFns } from "./indexImgLeft.vue?vue&type=template&id=72b226a4&scoped=true"
import script from "./indexImgLeft.vue?vue&type=script&lang=js"
export * from "./indexImgLeft.vue?vue&type=script&lang=js"
import style0 from "./indexImgLeft.vue?vue&type=style&index=0&id=72b226a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b226a4",
  null
  
)

export default component.exports